import { Button, CloseIcon, IconButton, Modal, Typography } from "@povio/ui";
import Image from "next/image";

import ModalCoverImage from "@/assets/images/modal-cover.png";

interface ContentChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueEditing: () => void;
  onRecalculate: () => void;
}

export const ContentChangeModal = ({ isOpen, onClose, onContinueEditing, onRecalculate }: ContentChangeModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="absolute top-0 right-0 left-0 z-0 h-[142px] w-full">
        <Image
          src={ModalCoverImage}
          alt="Modal cover"
          fill
          className="object-cover"
        />
      </div>
      <div className="z-10 flex w-full flex-col gap-6">
        <div className="flex items-center justify-between">
          <Typography
            as="h2"
            size="title-5"
            variant="prominent-1"
          >
            You&apos;ve changed your content. <br /> Would you like to recalculate?
          </Typography>
          <IconButton
            label="Close"
            icon={CloseIcon}
            onPress={onClose}
            variant="ghost"
            color="secondary"
            size="none"
          />
        </div>

        <Typography size="body-4">Update your Profile and your Lossdog score.</Typography>

        <div className="flex w-full gap-4">
          <Button
            variant="outlined"
            color="secondary"
            size="s"
            onPress={onContinueEditing}
            width="fill"
          >
            Continue
          </Button>
          <Button
            color="secondary"
            size="s"
            onPress={onRecalculate}
            width="fill"
          >
            Recalculate Now
          </Button>
        </div>
      </div>
    </Modal>
  );
};
